import { isEmpty } from 'lodash'
import { DateTime } from 'luxon'

export const isOneHourContractDuration = (value?: string) => {
  return value === '1H'
}

export const canAddDuration = (containerOfferServiceLength?: string | null) => {
  return (
    containerOfferServiceLength === null ||
    (containerOfferServiceLength &&
      !['', '1H', '1Y', '2Y', '3Y', '1M', '12M', '24M', '36M'].includes(
        containerOfferServiceLength
      ))
  )
}

export const canAddDurationForContract = (serviceLength?: number | null) => {
  return (
    serviceLength === null ||
    (serviceLength && ![1, 12, 24, 36].includes(serviceLength))
  )
}

export const getContractDurationMode = (offer?: {
  subscriptionEndDate?: string | null
  serviceLength?: number | string | null
  variableStartDate?: boolean | null
}): 'duration' | 'endDate' => {
  const isClone =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('from') === 'clone'
  if (
    isClone &&
    offer?.serviceLength == null &&
    offer?.variableStartDate === false
  ) {
    return 'endDate'
  }
  return !isEmpty(offer?.subscriptionEndDate) && offer?.serviceLength == null
    ? 'endDate'
    : 'duration'
}

export const getContractDurationInMonths = (
  startDate?: string | null,
  endDate?: string | null
) => {
  if (isEmpty(startDate) || isEmpty(endDate)) {
    return 0
  }
  const start = DateTime.fromISO(startDate as string).startOf('day')
  const end = DateTime.fromISO(endDate as string).startOf('day')
  if (!start.isValid || !end.isValid || end <= start) {
    return 0
  }
  return Math.ceil(end.diff(start, 'months').months)
}

export const formatContractDurationBetweenDates = (
  startDate?: string | null,
  endDate?: string | null,
  options: { endDate?: 'inclusive' | 'monthAnniversary' } = {}
) => {
  if (isEmpty(startDate) || isEmpty(endDate)) {
    return '-'
  }
  const start = DateTime.fromISO(startDate as string).startOf('day')
  const end = DateTime.fromISO(endDate as string).startOf('day')
  if (!start.isValid || !end.isValid || end <= start) {
    return '-'
  }

  const totalMonths = Math.floor(end.diff(start, 'months').months)
  const afterMonths = start.plus({ months: totalMonths })
  const leftoverDays = Math.floor(end.diff(afterMonths, 'days').days)
  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12
  const endsOnAnniversary =
    options.endDate === 'monthAnniversary' && leftoverDays === 0
  const days = endsOnAnniversary ? 0 : leftoverDays + 1

  const parts: string[] = []
  if (years > 0) {
    parts.push(`${years} year${years === 1 ? '' : 's'}`)
  }
  if (months > 0) {
    parts.push(`${months} month${months === 1 ? '' : 's'}`)
  }
  if (days > 0) {
    parts.push(`${days} day${days === 1 ? '' : 's'}`)
  }
  return parts.length > 0 ? parts.join(', ') : '-'
}

export const getDisplayContractDurationValue = (contractDuration?: string) => {
  if (isEmpty(contractDuration)) {
    return ''
  }

  if (contractDuration === '1H') {
    return 'Hourly'
  } else {
    const contractDurationValue = contractDuration?.slice(0, -1)
    if (contractDuration?.endsWith('M')) {
      return `${contractDurationValue} ${
        contractDurationValue === '1' ? 'month' : 'months'
      }`
    } else if (contractDuration?.endsWith('Y')) {
      return `${contractDurationValue} ${
        contractDurationValue === '1' ? 'year' : 'years'
      }`
    } else if (contractDuration?.endsWith('D')) {
      return `${contractDurationValue} ${
        contractDurationValue === '1' ? 'day' : 'days'
      }`
    }
  }
}
